import { render } from "./CarSales.vue?vue&type=template&id=2b0e9e02"
import script from "./CarSales.vue?vue&type=script&lang=js"
export * from "./CarSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/CarSales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b0e9e02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b0e9e02', __exports__)) {
    api.reload('2b0e9e02', __exports__)
  }
  
  module.hot.accept("./CarSales.vue?vue&type=template&id=2b0e9e02", () => {
    api.rerender('2b0e9e02', render)
  })

}


export default __exports__